import shared0_default from "@use-it/event-listener";
import shared1_default from "Addons/search/pageType";
import shared2_default from "Components/errorBoundary";
import { vehicleDiscardingRequested as shared3_vehicleDiscardingRequested, vehicleSelected as shared3_vehicleSelected } from "Core/actions/fitmentSearch/index";
import { focusGuardProps as shared4_focusGuardProps } from "Core/hooks/autofocus";
import { useResizeState as shared5_useResizeState } from "Core/hooks/index";
import { fitmentSearchBaseFieldsSelector as shared6_fitmentSearchBaseFieldsSelector, fitmentSearchFieldsSelector as shared6_fitmentSearchFieldsSelector, garageDataSelector as shared6_garageDataSelector, selectedVehicleSelector as shared6_selectedVehicleSelector } from "Core/selectors/fitmentSearch/index";
import { searchRequestQuerySelector as shared7_searchRequestQuerySelector } from "Core/selectors/search";
import shared8_default, { useDispatch as shared8_useDispatch, useSelector as shared8_useSelector } from "Core/store";
import { logNetworkRequest as shared9_logNetworkRequest } from "Diagnostics/diagnostics";
import { Vehicle as shared10_Vehicle } from "Models/index";
import { mainConfig as shared11_mainConfig } from "Models/uiConfig/componentlessWidgetsConfig";
import shared12_default from "Models/uiConfig/fitmentSearchConfig";
import shared13_default from "Models/uiConfig/productConfig";
import shared14_default from "Models/uiConfig/requestConfig";
import shared15_default from "Models/uiConfig/uiConfig";
import shared16_default from "Modules/analytics";
import { getUriFromRequest as shared17_getUriFromRequest } from "Modules/converter/index";
import { GET as shared18_GET, abortControllerCreator as shared18_abortControllerCreator } from "Modules/serverApi/common/httpClient";
import { PARTS_ADVISOR_ENDPOINT as shared19_PARTS_ADVISOR_ENDPOINT } from "Modules/serverApi/endpoints";
import { search as shared20_search } from "Modules/serverApi/index";
import shared21_default from "Modules/serverApi/track";
import { SEARCH_RESPONSE_ERROR_STATES as shared22_SEARCH_RESPONSE_ERROR_STATES } from "Modules/serverApi/types";
import { map as shared23_map } from "Utils/array";
import { createOnImageError as shared24_createOnImageError } from "Utils/components";
import { getStringProperty as shared25_getStringProperty, isBoolean as shared25_isBoolean, isString as shared25_isString } from "Utils/guards";
import shared26_default from "Utils/translate";
import { getItem as shared27_getItem, getPartsAdvisorOpen as shared27_getPartsAdvisorOpen, setItem as shared27_setItem, setPartsAdvisorOpen as shared27_setPartsAdvisorOpen } from "Utils/userStorage";
import shared28_default from "Utils/userStorageKeys";
import { createElement as shared29_createElement, render as shared29_render } from "preact";
import { useCallback as shared30_useCallback, useEffect as shared30_useEffect, useLayoutEffect as shared30_useLayoutEffect, useMemo as shared30_useMemo, useReducer as shared30_useReducer, useRef as shared30_useRef, useState as shared30_useState } from "preact/hooks";
import { Fragment as shared31_Fragment, jsx as shared31_jsx, jsxs as shared31_jsxs } from "preact/jsx-runtime";
import { Provider as shared32_Provider } from "react-redux";

export default function createChunkSharedModules() {
  return {
    "@use-it/event-listener": {
      __esModule: true,
      get "default"() { return shared0_default; },
    },
    "Addons/search/pageType": {
      __esModule: true,
      get "default"() { return shared1_default; },
    },
    "Components/errorBoundary": {
      __esModule: true,
      get "default"() { return shared2_default; },
    },
    "Core/actions/fitmentSearch/index": {
      __esModule: true,
      get "vehicleDiscardingRequested"() { return shared3_vehicleDiscardingRequested; },
      get "vehicleSelected"() { return shared3_vehicleSelected; },
    },
    "Core/hooks/autofocus": {
      __esModule: true,
      get "focusGuardProps"() { return shared4_focusGuardProps; },
    },
    "Core/hooks/index": {
      __esModule: true,
      get "useResizeState"() { return shared5_useResizeState; },
    },
    "Core/selectors/fitmentSearch/index": {
      __esModule: true,
      get "fitmentSearchBaseFieldsSelector"() { return shared6_fitmentSearchBaseFieldsSelector; },
      get "fitmentSearchFieldsSelector"() { return shared6_fitmentSearchFieldsSelector; },
      get "garageDataSelector"() { return shared6_garageDataSelector; },
      get "selectedVehicleSelector"() { return shared6_selectedVehicleSelector; },
    },
    "Core/selectors/search": {
      __esModule: true,
      get "searchRequestQuerySelector"() { return shared7_searchRequestQuerySelector; },
    },
    "Core/store": {
      __esModule: true,
      get "default"() { return shared8_default; },
      get "useDispatch"() { return shared8_useDispatch; },
      get "useSelector"() { return shared8_useSelector; },
    },
    "Diagnostics/diagnostics": {
      __esModule: true,
      get "logNetworkRequest"() { return shared9_logNetworkRequest; },
    },
    "Models/index": {
      __esModule: true,
      get "Vehicle"() { return shared10_Vehicle; },
    },
    "Models/uiConfig/componentlessWidgetsConfig": {
      __esModule: true,
      get "mainConfig"() { return shared11_mainConfig; },
    },
    "Models/uiConfig/fitmentSearchConfig": {
      __esModule: true,
      get "default"() { return shared12_default; },
    },
    "Models/uiConfig/productConfig": {
      __esModule: true,
      get "default"() { return shared13_default; },
    },
    "Models/uiConfig/requestConfig": {
      __esModule: true,
      get "default"() { return shared14_default; },
    },
    "Models/uiConfig/uiConfig": {
      __esModule: true,
      get "default"() { return shared15_default; },
    },
    "Modules/analytics": {
      __esModule: true,
      get "default"() { return shared16_default; },
    },
    "Modules/converter/index": {
      __esModule: true,
      get "getUriFromRequest"() { return shared17_getUriFromRequest; },
    },
    "Modules/serverApi/common/httpClient": {
      __esModule: true,
      get "GET"() { return shared18_GET; },
      get "abortControllerCreator"() { return shared18_abortControllerCreator; },
    },
    "Modules/serverApi/endpoints": {
      __esModule: true,
      get "PARTS_ADVISOR_ENDPOINT"() { return shared19_PARTS_ADVISOR_ENDPOINT; },
    },
    "Modules/serverApi/index": {
      __esModule: true,
      get "search"() { return shared20_search; },
    },
    "Modules/serverApi/track": {
      __esModule: true,
      get "default"() { return shared21_default; },
    },
    "Modules/serverApi/types": {
      __esModule: true,
      get "SEARCH_RESPONSE_ERROR_STATES"() { return shared22_SEARCH_RESPONSE_ERROR_STATES; },
    },
    "Utils/array": {
      __esModule: true,
      get "map"() { return shared23_map; },
    },
    "Utils/components": {
      __esModule: true,
      get "createOnImageError"() { return shared24_createOnImageError; },
    },
    "Utils/guards": {
      __esModule: true,
      get "getStringProperty"() { return shared25_getStringProperty; },
      get "isBoolean"() { return shared25_isBoolean; },
      get "isString"() { return shared25_isString; },
    },
    "Utils/translate": {
      __esModule: true,
      get "default"() { return shared26_default; },
    },
    "Utils/userStorage": {
      __esModule: true,
      get "getItem"() { return shared27_getItem; },
      get "getPartsAdvisorOpen"() { return shared27_getPartsAdvisorOpen; },
      get "setItem"() { return shared27_setItem; },
      get "setPartsAdvisorOpen"() { return shared27_setPartsAdvisorOpen; },
    },
    "Utils/userStorageKeys": {
      __esModule: true,
      get "default"() { return shared28_default; },
    },
    "preact": {
      __esModule: true,
      get "createElement"() { return shared29_createElement; },
      get "render"() { return shared29_render; },
    },
    "preact/hooks": {
      __esModule: true,
      get "useCallback"() { return shared30_useCallback; },
      get "useEffect"() { return shared30_useEffect; },
      get "useLayoutEffect"() { return shared30_useLayoutEffect; },
      get "useMemo"() { return shared30_useMemo; },
      get "useReducer"() { return shared30_useReducer; },
      get "useRef"() { return shared30_useRef; },
      get "useState"() { return shared30_useState; },
    },
    "preact/jsx-runtime": {
      __esModule: true,
      get "Fragment"() { return shared31_Fragment; },
      get "jsx"() { return shared31_jsx; },
      get "jsxs"() { return shared31_jsxs; },
    },
    "react-redux": {
      __esModule: true,
      get "Provider"() { return shared32_Provider; },
    },
  };
}
